import React from 'react';
import { ClientSnapshotContext } from './useProfileProvider';

export const useClientSnapshot = () => {
    const clientSnapshot = React.useContext(ClientSnapshotContext);
    return clientSnapshot;
};
